import { useState } from 'react'
import { supabase } from '@/lib/supabase'
import { Label } from '@/components/ui/label'
import { toast } from 'sonner'

interface SettingsFormProps {
  emailNotifications: boolean
  profileId: string
}

export function SettingsForm({ emailNotifications, profileId }: SettingsFormProps) {
  const [notifications, setNotifications] = useState(emailNotifications)
  const [isLoading, setIsLoading] = useState(false)

  const handleToggle = async (checked: boolean) => {
    setIsLoading(true)
    setNotifications(checked)

    try {
      const { error } = await supabase
        .from('customer_profiles')
        .update({ email_notifications: checked })
        .eq('id', profileId)

      if (error) {
        // Revert on error
        setNotifications(!checked)
        toast.error('Failed to update settings')
        return
      }

      toast.success('Settings updated')
    } catch {
      setNotifications(!checked)
      toast.error('An unexpected error occurred')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="space-y-0.5">
          <Label>Order Updates</Label>
          <p className="text-sm text-muted-foreground">
            Receive emails about your order status and shipping updates
          </p>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={notifications}
          disabled={isLoading}
          onClick={() => handleToggle(!notifications)}
          className={`
            relative inline-flex h-6 w-11 items-center rounded-full transition-colors
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
            disabled:cursor-not-allowed disabled:opacity-50
            ${notifications ? 'bg-primary' : 'bg-input'}
          `}
        >
          <span
            className={`
              inline-block h-4 w-4 transform rounded-full bg-background shadow-lg transition-transform
              ${notifications ? 'translate-x-6' : 'translate-x-1'}
            `}
          />
        </button>
      </div>

      <div className="flex items-center justify-between">
        <div className="space-y-0.5">
          <Label>Promotional Emails</Label>
          <p className="text-sm text-muted-foreground">
            Receive emails about new products and special offers
          </p>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={notifications}
          disabled={isLoading}
          onClick={() => handleToggle(!notifications)}
          className={`
            relative inline-flex h-6 w-11 items-center rounded-full transition-colors
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
            disabled:cursor-not-allowed disabled:opacity-50
            ${notifications ? 'bg-primary' : 'bg-input'}
          `}
        >
          <span
            className={`
              inline-block h-4 w-4 transform rounded-full bg-background shadow-lg transition-transform
              ${notifications ? 'translate-x-6' : 'translate-x-1'}
            `}
          />
        </button>
      </div>
    </div>
  )
}
